<div class="modal-header">
    <h4 class="modal-title drop-modal-title" id="modal-basic-title">FILTERS</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal(true)"></button>
</div>
<div class="modal-body">
    <div class="addresses-wrapper filter" *ngIf="initialized && partnerLocations.length">
        <div class="filter-section-header">
            <h3 class="heading">Schedule</h3>
            <button
                *ngIf="filterModel.PartnerKey"
                type="button"
                class="section-clear-btn"
                (click)="resetScheduleToHost()"
            >
                Clear
            </button>
        </div>
        <div class="addresses-grid">
            <div
                class="address-card"
                role="button"
                tabindex="0"
                [attr.aria-pressed]="isHostScheduleSelected()"
                [class.selected]="isHostScheduleSelected()"
                (click)="selectHostSchedule()"
                (keydown.enter)="selectHostSchedule()"
                (keydown.space)="$event.preventDefault(); selectHostSchedule()"
            >
                <span class="address-name">{{ hostScheduleLabel }}</span>
                <span class="selection-icon" aria-hidden="true">
                    <i [ngClass]="isHostScheduleSelected() ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                </span>
            </div>
            <div
                *ngFor="let partner of partnerLocations"
                class="address-card"
                role="button"
                tabindex="0"
                [attr.aria-pressed]="isPartnerLocationSelected(partner.key)"
                [class.selected]="isPartnerLocationSelected(partner.key)"
                (click)="selectPartnerLocation(partner.key)"
                (keydown.enter)="selectPartnerLocation(partner.key)"
                (keydown.space)="$event.preventDefault(); selectPartnerLocation(partner.key)"
            >
                <span class="address-name">{{ partner.name }}</span>
                <span class="selection-icon" aria-hidden="true">
                    <i [ngClass]="isPartnerLocationSelected(partner.key) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                </span>
            </div>
        </div>
    </div>

    <div class="instructors-wrapper filter" *ngIf="initialized && hasFilter('instructor')">
        <div class="filter-section-header">
            <h3 class="heading">Instructors</h3>
            <button
                *ngIf="filterModel.InstructorIds.length > 0"
                type="button"
                class="section-clear-btn"
                (click)="clearInstructors()"
            >
                Clear
            </button>
        </div>
        <div class="instructors-scroll">
            <ng-container *ngFor="let instructor of displayInstructors()">
                <div
                    *ngIf="instructor.State == 1"
                    class="instructor-card"
                    role="button"
                    tabindex="0"
                    [attr.aria-pressed]="isInstructorSelected(instructor.Id)"
                    [class.selected]="isInstructorSelected(instructor.Id)"
                    (click)="instructorToggle(instructor.Id)"
                    (keydown.enter)="instructorToggle(instructor.Id)"
                    (keydown.space)="$event.preventDefault(); instructorToggle(instructor.Id)"
                >
                    <img
                        class="instructor-photo"
                        [src]="getInstructorImageUrl(instructor)"
                        [alt]="instructor.Person.FirstName"
                    />
                    <span class="selection-icon" aria-hidden="true">
                        <i [ngClass]="isInstructorSelected(instructor.Id) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                    </span>
                    <span class="instructor-name">{{ instructor.Person.FirstName }}</span>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="studios-wrapper filter" *ngIf="initialized && hasFilter('studio')">
        <div class="filter-section-header">
            <h3 class="heading">Studios</h3>
            <button
                *ngIf="filterModel.StudioIds.length > 0"
                type="button"
                class="section-clear-btn"
                (click)="clearStudios()"
            >
                Clear
            </button>
        </div>
        <div class="studios-grid">
            <div
                *ngFor="let studio of displayStudios()"
                class="studio-card"
                role="button"
                tabindex="0"
                [attr.aria-pressed]="isStudioSelected(studio.Id)"
                [class.selected]="isStudioSelected(studio.Id)"
                (click)="studioToggle(studio.Id)"
                (keydown.enter)="studioToggle(studio.Id)"
                (keydown.space)="$event.preventDefault(); studioToggle(studio.Id)"
            >
                <img
                    *ngIf="studio.Image?.UploadedUrl"
                    [src]="studio.Image.UploadedUrl"
                    [alt]="studio.Name"
                    class="studio-logo"
                />
                <span *ngIf="!studio.Image?.UploadedUrl" class="studio-name">{{ studio.Name }}</span>
                <span class="selection-icon" aria-hidden="true">
                    <i [ngClass]="isStudioSelected(studio.Id) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                </span>
            </div>
        </div>
    </div>

    <div class="addresses-wrapper filter" *ngIf="initialized && hasFilter('address') && displayAddresses().length">
        <div class="filter-section-header">
            <h3 class="heading">Address</h3>
            <button
                *ngIf="filterModel.AddressIds.length > 0"
                type="button"
                class="section-clear-btn"
                (click)="clearAddresses()"
            >
                Clear
            </button>
        </div>
        <div class="addresses-grid">
            <div
                *ngFor="let address of displayAddresses()"
                class="address-card"
                role="button"
                tabindex="0"
                [attr.aria-pressed]="isAddressSelected(address.Id)"
                [class.selected]="isAddressSelected(address.Id)"
                (click)="addressToggle(address.Id)"
                (keydown.enter)="addressToggle(address.Id)"
                (keydown.space)="$event.preventDefault(); addressToggle(address.Id)"
            >
                <span class="address-name">{{ address.Name }}</span>
                <span class="selection-icon" aria-hidden="true">
                    <i [ngClass]="isAddressSelected(address.Id) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                </span>
            </div>
        </div>
    </div>

    <div class="timing-wrapper filter" *ngIf="initialized && hasFilter('time')">
        <div class="filter-section-header">
            <h3 class="heading">Start Time</h3>
            <button
                *ngIf="!isDefaultTimeRange()"
                type="button"
                class="section-clear-btn"
                (click)="clearTimeRange()"
            >
                Clear
            </button>
        </div>
        <div class="filter-timing-slider-container">
            <ngx-slider
                [(value)]="filterModel.StartTime"
                [(highValue)]="filterModel.EndTime"
                [options]="timingOptions"
                (userChange)="onTimingSliderChange()"
                class="filter-timing-slider"
            ></ngx-slider>
        </div>
        <div class="time-range-labels">
            <span>Start: {{ formatTime(filterModel.StartTime) }}</span>
            <span>End: {{ formatTime(filterModel.EndTime) }}</span>
        </div>
    </div>
</div>
<div class="modal-footer filter-modal-footer">
    <button type="button" class="clear-btn" (click)="clearFilter()">Clear</button>
    <button type="button" class="btn btn-outline-primary save-btn" [disabled]="submitted" (click)="filterSessions()">
        <div *ngIf="submitted" class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Showing Classes...</span>
        </div>
        <span *ngIf="!submitted">SAVE</span>
    </button>
</div>
